export default function mobileMenu() {
	let body = $('body');
	let mobileMenu = $('#mobile-navigation');
	let backdrop = mobileMenu.find('> .backdrop');
	let menu = mobileMenu.find('> .menu');

	let close = function () {
		body.removeClass('navbar-active');
	};

	backdrop.click(close);

	$('#menu').click(() => {
		mobileMenu.css('display', '');
		setTimeout(() => body.addClass('navbar-active'), 1);
	});
}